import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const ELEVATION_CLASSES = {
    0: '',
    1: 'shadow-elev-1',
    2: 'shadow-elev-2',
    3: 'shadow-elev-3',
};
/**
 * Surface container. Border + card token background; optional warm elevation.
 * Cards are the QELM layout language — do NOT nest a Card inside a Card.
 */
export const Card = forwardRef(({ className, elevation = 1, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('rounded-xl border border-border bg-card text-card-foreground', ELEVATION_CLASSES[elevation], className), ...props })));
Card.displayName = 'Card';
export const CardHeader = forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex flex-col gap-1 p-5', className), ...props })));
CardHeader.displayName = 'CardHeader';
export const CardTitle = forwardRef(({ className, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('font-display text-lg font-semibold leading-tight tracking-tight', className), ...props })));
CardTitle.displayName = 'CardTitle';
export const CardDescription = forwardRef(({ className, ...props }, ref) => (_jsx("p", { ref: ref, className: cn('text-sm text-muted-foreground', className), ...props })));
CardDescription.displayName = 'CardDescription';
export const CardContent = forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('p-5 pt-0', className), ...props })));
CardContent.displayName = 'CardContent';
export const CardFooter = forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex items-center gap-2 border-t border-border p-5', className), ...props })));
CardFooter.displayName = 'CardFooter';
